export const BlogSchemas = {
    blogListingWidget: "BlogItemListSchema",
    blogDetailPage: "BlogPostingSchema",
};

export interface ProductNonStandardVendors {
    material: string;
    name: string;
}
